export default {
    methods: {
        post(replace) {
            this.load = true;

            this.$http.post(`${this.$store.state.api}/old-cars/index?imported=1&skipHistory=1`,
                {
                    filters: this.getFilter,
                    all: this.all,
                    sort: this.$store.state.sorting || this.filters.sort,
                    alc: replace ? null : this.getCarsIds,
                    withMainImg: true,
                    imported: 0
                },
                {
                    before(request) {
                        if (this.previousRequest) {
                            this.previousRequest.abort();
                        }

                        // set previous request on Vue instance
                        this.previousRequest = request;
                    }
                }
            ).then(
                response => {
                    this.load = false;
                    this.busy = false;
                    if (response.body) {
                        this.oldCars = response.body
                        this.addFilersName();
                        this.all = false;

                        if (typeof response.body.brands != "undefined") {
                            this.brands = response.body.brands;

                            let data = this.brands;
                            for (let k in data) {
                                data[k].name = data[k].company;
                            }
                        }

                        if (typeof response.body.brand_model != "undefined") {
                            this.brand_model = response.body.brand_model;
                        }

                        if (typeof response.body.fuel_type != "undefined") {
                            this.fuel_type = response.body.fuel_type;
                        }

                        if (typeof response.body.categories != "undefined") {
                            this.categories = response.body.categories;
                        }

                        if (typeof response.body.cars != "undefined") {
                            for (let k in response.body.cars) {
                                for (let kk in response.body.cars[k]) {
                                    if(typeof response.body.cars[k][kk] == 'object'){
                                        response.body.cars[k][kk].map(e => {
                                            e.is_price_changing = parseInt(e.is_price_changing);
                                            e.is_special_price = parseInt(e.is_special_price);
                                            return e;
                                        });
                                    }
                                    this.getFuelType(response.body.cars[k][kk].ft, response.body.cars[k][kk].ft2);
                                }
                            }

                            this.carsInSliders = response.body.cars.map(car => {
                                car.fuel_id = response.body.fuel_type.find(ft => ft.name === car.title).id
                                return car
                            })
                        }

                        if (typeof response.body.categories != "undefined") {
                            if (
                                response.body.categories.length > 0 &&
                                response.body.categories != this.flokkar
                            ) {
                                this.extraType = true;
                            }
                            this.flokkar = response.body.categories;
                        }

                        if (typeof response.body.resultCount != "undefined") {
                            this.resultCount = response.body.resultCount;
                            this.$store.state.resultCount = this.resultCount;
                        }

                        if (typeof response.body.isSub != "undefined") {
                            this.isSub =
                                parseInt(response.body.isSub) > 0
                                    ? parseInt(response.body.isSub)
                                    : false;
                            this.$store.state.sub = this.isSub;
                        }

                        if (typeof response.body.other != "undefined") {
                            this.other = response.body.other;
                        }

                        if (typeof response.body.vt != "undefined") {
                            this.vehicle_type = response.body.vt;
                        }

                        if (typeof response.body.result != "undefined") {
                            for (let k in response.body.result) {
                                response.body.result[k].fuel_type = this.getFuelType(response.body.result[k].ft, response.body.result[k].ft2);
                                response.body.result[k] = this.convertCar(response.body.result[k]);
                            }

                            if (this.oldCarsLoadedData) {
                                this.setData({
                                    field: 'moduleOldCars.cars.items',
                                    data: this.$store.state.oldCarsLoadedCars
                                })

                                this.oldCarsLoadedData = false;
                                this.$store.state.moduleOldCars.cars.loaded = true;
                            }else if (!this.carsLoaded || this.mounted) {
                                if (replace) {
                                    this.setData({
                                        field: 'moduleOldCars.cars.items',
                                        data: response.body.result
                                    })
                                    this.$store.state.oldCarsLoadedCars = null;
                                } else {
                                    this.setData({
                                        field: 'moduleOldCars.cars.items',
                                        data: [...this.carsByFilter, ...response.body.result]
                                    });
                                    this.$store.state.oldCarsLoadedCars = [...this.carsByFilter, ...response.body.result];
                                }
                            }

                            if(!this.showMenu){
                                this.insertAd(replace);
                                this.mounted = true
                            }

                            if (this.carsByFilter.length > 0) {
                                this.showRes = true;
                            } else {
                                this.showRes = false;
                            }
                        }
                        this.subscriber = response.body.sub;

                        if (typeof response.body.girartegund != "undefined") {
                            this.girartegund = response.body.girartegund;
                        }

                        $(".owl-carousel.index-slider").trigger("refresh.owl.carousel");

                        this.setData({
                            field: 'moduleOldCars.cars.loaded',
                            data: true
                        })
                    }

                    //this.$store.state.specialText = response.body.special_text;

                    document.dispatchEvent(new Event('renderer-ready'));
                },
                response => {
                    this.error = response;
                }
            )
                .catch((e) => {
                    console.log("Caught", e);
                })
        },
    }
}
